import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Calendar from "../../calendar/Calendar";
import Cars from "../../cars/Cars";
import TableData from "../../table/TableData";
import dayjs from "dayjs";
import axios from "axios";
import { url } from "../../../utils/url";
import { isMobile } from "../../../utils/functions";
import updateLocale from "dayjs/plugin/updateLocale";

// move monday to be the first day in the calendar
dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});

const DailyReport = () => {
  const [date, setDate] = useState(dayjs(new Date()));
  const [carId, setCarId] = useState("");
  const [checkedTable, setCheckedTable] = useState(1);
  const [rows, setRows] = useState([]);
  const [travelData, setTravelData] = useState({});
  const [photo, setPhoto] = useState("");
  const [unfulfilled, setUnfulfilled] = useState(false);
  const [savedChanges, setSavedChanges] = useState(false);
  const [users, setUsers] = useState(null);
  const [user, setUser] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!carId) {
      return;
    }

    setUnfulfilled(false);
    setSavedChanges(false);
    setError(null);
    const dateIsoString = date.$d.toISOString();

    (async () => {
      try {
        const checkTravelRequest = await axios.get(`${url}travels/${dateIsoString}?vehicleId=${carId}`, { withCredentials: true });

        if (!checkTravelRequest.data.length) {
          setUnfulfilled(true);
          setPhoto("");
          setTravelData({});
          setRows([]);
          return;
        }

        const getUsers = await axios.get(`${url}users`, { withCredentials: true });
        const users = await checkTravelRequest.data.map((el) => el.userId);
        const filteredUsers = await getUsers.data.filter((user) => users.includes(user.id));

        let currentUser = await checkTravelRequest.data.find((el) => el.userId === user);
        
        if (!currentUser) {
          currentUser = await checkTravelRequest.data.find((el) => el.userId === checkTravelRequest.data[0].userId);
          setUser(checkTravelRequest.data[0].userId);
        }

        const getPhotoRequest = await axios.get(`${url}attached-files/travels/${currentUser.id}`, { withCredentials: true });
       
        setUsers(filteredUsers);
        setRows(JSON.parse(currentUser.data));
        setTravelData(currentUser);
        setPhoto(getPhotoRequest.data[0]);
        setCheckedTable(currentUser.travelVerifStatusId);
      } catch (err) {
        setError("Възникна проблем! Моля опитайте по-късно");
        console.log(err);
      }
    })();
  }, [carId, date, user]);

  const changeTableHandler = async () => {
    setError(null);

    const travel = {...travelData};
    travel.data = JSON.stringify(rows);
    travel.travelVerifStatusId = checkedTable;
    try {
      await axios.put(`${url}travels/${travelData.id}`, travel, { withCredentials: true });
      setSavedChanges(true);
      setTimeout(() => {
        setSavedChanges(false);
      }, 3000);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "30px",
        padding: {
          xs: 0,
          lg: "30px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          width: "60%",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
        }}
      >
        <Calendar date={date} setDate={setDate} />
        <Cars setCarId={setCarId} />
      </Box>
      {error && <Typography color="red">{error}</Typography>}
      {unfulfilled && <Typography>Няма информация за тази дата</Typography>}
      {savedChanges ? (
        <Typography color="green">Промените бяха запазени успешно</Typography>
      ) : (
        rows.length > 0 && (
          <>
            <Box display="flex">
              {users.map((driver) => (
                <Typography
                  sx={{
                    cursor: "pointer",
                    padding: "10px",
                    borderBottom: users.length > 1 && driver.id === user ? "1px solid blue" : "",
                    color: users.length > 1 && driver.id === user ? "blue" : "black",
                  }}
                  key={driver.id}
                  onClick={() => setUser(driver.id)}
                >
                  {driver.firstName}
                </Typography>
              ))}
            </Box>
            <TableData rows={rows} setRows={setRows} checkedTable={checkedTable} />
            {travelData.notes && <Typography>{travelData.notes}</Typography>}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "300px",
              }}
            >
              <Button variant="contained" color="warning" onClick={() => (checkedTable !== 2 ? setCheckedTable(2) : setCheckedTable(1))}>
                Прегледана
              </Button>
              <Button variant="contained" onClick={() => (checkedTable !== 3 ? setCheckedTable(3) : setCheckedTable(1))}>
                Проверена
              </Button>
            </Box>
            <Button variant="contained" onClick={changeTableHandler}>
              Запази Промените
            </Button>
            {error && <Typography color="red">{error}</Typography>}
            {photo && <img src={`${url}attached-files/${photo.id}`} alt="снимка" width={isMobile() ? 300 : 600} />}
          </>
        )
      )}
    </Box>
  );
};

export default DailyReport;
